module.exports = __webpack_public_path__ + "img/fashion_53.fc04ba3d.jpg";